export default __webpack_public_path__ + "static/media/CircleLine.9aca9580.svg";